import { render, staticRenderFns } from "./privacyListView.vue?vue&type=template&id=142d9956&scoped=true&"
import script from "./privacyListView.vue?vue&type=script&lang=js&"
export * from "./privacyListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142d9956",
  null
  
)

export default component.exports